import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import { Checkbox, FormControlLabel } from "@mui/material";
const LegislativeMapMenu = ({ isMenuOpen, alldata, handleChange }) => {
    return (
        <>
            {
                isMenuOpen &&
                <div className="crie-filter-inner-container-drop">
                    <div>
                        {
                            alldata?.map((item, index) => (
                                <div className="location_filter_leads_crie lg-map-filter-leads" onClick={() => handleChange(item)}>
                                    <div className="AI-leader-checkbox-and-data-list">
                                        <div className="checkbox-select-data">
                                            <MenuItem className="menuitems">{item}</MenuItem>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            }
        </>
    );
}
export default LegislativeMapMenu